import React, { useEffect } from 'react';
import './DurationOverlay.scss';
import { Button, EButtonType, Input, KitIcons } from '@repo/apg-ui';
import { FormattedMessage } from 'react-intl';

interface Props {
  durationLabels?: string;
  placeholderText?: string;
  inputValue: any;
  onChange?: any;
  isDisabled?: boolean;
}

export const DurationOverlay = ({ isDisabled, placeholderText, durationLabels, inputValue, onChange }: Props) => {
  const [duration, setDuration] = React.useState<number>(inputValue);

  useEffect(() => {
    setDuration(inputValue);
  }, [inputValue]);
  if (isDisabled) return null;
  return (
    <div className='overlay-content duration' id='root'>
      <div className='d-flex align-items-start justify-content-start gap-3 w-100'>
        <div className='d-flex flex-column position-relative align-items-start justify-content-start'>
          <div className='subtitle'>
            <FormattedMessage id='ec.checkout.duration' defaultMessage='Spotlänge' />
          </div>
          <div className='d-flex align-items-center justify-content-center gap-3'>
            <div className='input-wrap'>
              <Input
                value={duration}
                name={'duration-input'}
                type='text'
                placeholder={placeholderText || 'Duration'}
                onChange={(name, _value) => {
                  setDuration(_value);
                }}
                inputWrapperClass='mt-0 p-0 duration-input'
              />
              <span className='input-label'>{durationLabels}</span>
            </div>
            <div className='input-action'>
              <Button
                buttonType={EButtonType.PillSmall}
                onClick={() => {
                  onChange(duration);
                }}
              >
                <div className='button-svg'>
                  <KitIcons.CheckIcon className='check-svg' />
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
